import { combineSlices } from '@reduxjs/toolkit'
import profileApi from 'api/profile'
import templateApi from 'api/templateApi'
import audienceApi from 'api/audienceApi'
import walletApi from 'api/walletApi'
import advertisementApi from 'api/advertisementApi'
import campaignApi from 'api/campaignApi'
import channelApi from 'api/channelApi'
import dashboardApi from 'api/dashboardApi'
import enquiryApi from 'api/enquiryApi'
import companyApi from 'api/companyApi'

const rootReducer = combineSlices(
  channelApi,
  profileApi,
  dashboardApi,
  audienceApi,
  walletApi,
  advertisementApi,
  templateApi,
  channelApi,
  campaignApi,
  enquiryApi,
  companyApi
)

export type RootState = ReturnType<typeof rootReducer>
export default rootReducer
